import React from "react";
import Row from "@amzn/meridian/row";
import { ApproachType } from "../../../../endpoints/getExpandedComps";
import { PropertyCard } from "../PropertyCard";
import Column from "@amzn/meridian/column";

interface PropertyListProps {
    displayedProperties: any[];
    viewType: ApproachType;
    handleAdd: (recordId: string) => void;
    handleRemove: (recordId: string) => void;
    handleViewDetails: (property: any) => void;
}

export const PropertyList: React.FC<PropertyListProps> = ({
    displayedProperties,
    viewType,
    handleAdd,
    handleRemove,
    handleViewDetails,
}) => {
    const groupedProperties = displayedProperties.reduce((acc, property, index) => {
        const groupIndex = Math.floor(index / 3);
        if (!acc[groupIndex]) {
            acc[groupIndex] = [];
        }
        acc[groupIndex].push(property);

        return acc;
    }, [] as any[][]);

    return (
        <Column spacing="400" width="fill" spacingInset={"0 400 0 0"}>
            {groupedProperties.map((group, groupIndex) => (
                <Row
                    key={groupIndex}
                    spacing="400"
                    alignmentHorizontal="start"
                    width="fill"
                    spacingInset="200 0"
                >
                    {group.map(property => {
                        const displayYear =
                            viewType === ApproachType.SALES
                                ? (property.saleDate?.substring(0, 4) ?? "-")
                                : (property.leaseStartDate?.substring(0, 4) ?? "-");

                        return (
                            <PropertyCard
                                key={property.recordId}
                                isAdded={property.enable || property.uiEnabled}
                                onAdd={() => handleAdd(property.recordId)}
                                onRemove={() => handleRemove(property.recordId)}
                                onViewDetails={() => handleViewDetails(property)}
                                address={property.address}
                                location={`${property.city}, ${property.state} ${
                                    property.zip === "None" ? " " : property.zip
                                }`}
                                sqft={property.buildingSize}
                                age={new Date().getFullYear() - property.yearBuilt}
                                distance={property?.distanceFromSource?.toFixed(1)}
                                year={displayYear}
                            />
                        );
                    })}
                </Row>
            ))}
        </Column>
    );
};
